'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Service gérant la liste des indexes.
 * Lié à la resource 'IndexesResource'.
 */
ngModule.factory("indexationService", function ($http, $translate) {
  var allIndexes = [];
  return {
    /**
     * Load all indices once at startup for synchronous call to main usages methods.
     * Require that $translate already loaded bundles.
     */
    $load: function $load() {
      return $http.get('/rest/indexes/all').then(function (response) {
        allIndexes = _.map(response.data, function (index) {
          return _.extend(index, {
            label: $translate('index.' + index.id),
            groupLabel: $translate('index.groups.' + index.groupe)
          });
        });
        return allIndexes;
      });
    },
    /**
     * Retourne la liste complete des indices disponibles, de manière synchrone. {id, groupe, type, label}
     */
    getAll: function getAll() {
      return allIndexes; // .slice(0) to clone ?
    },
    /**
     * Retourne l'indice pour l'identifiant donné. {id, groupe, type, label}
     */
    getIndice: function getIndice(indexId) {
      return _.find(allIndexes, {
        id: indexId
      });
    },
    /**
     * les indices du client sous forme de Promise
     * @return une liste de {id, groupe, type, label}
     */
    getIndicesClient: function getIndicesClient() {
      return $http.get('/rest/indexes/indexClient').then(function (response) {
        return _.map(response.data, function (val) {
          return {
            id: val.id,
            groupe: $translate('index.groups.' + val.groupe),
            type: val.type,
            label: $translate('index.' + val.id)
          };
        });
      });
    },
    /**
     * les indices des enveloppes par catégorie du client sous forme de Promise - map <category, list<indexId>>
     */
    getIndicesClientEnveloppeByCategory: function getIndicesClientEnveloppeByCategory() {
      return $http.get('/rest/indexes/indexClientEnveloppeByCategory').then(function (response) {
        return response.data;
      });
    },
    /**
     * les indices des enveloppes par catégorie du client sous forme de Promise - List<IndexDto> avec en group la categorie
     */
    getIndicesClientEnveloppeByCategoryAsList: function getIndicesClientEnveloppeByCategoryAsList() {
      return $http.get('/rest/indexes/indexClientEnveloppeByCategoryAsList').then(function (response) {
        _.each(response.data, function (d) {
          d.groupe = $translate('indexClientEnveloppeCategory.' + d.groupe);
        });
        return response.data;
      });
    },
    /**
     * synchrone
     * @returns {{id: string, label: string}}
     */
    getTauxFixe: function getTauxFixe() {
      // TODO PGA : probablement mauvaise pratique, vérifier les usages.
      return {
        id: 'TAUX_FIXE',
        label: 'Taux fixe'
      };
    },
    /**
     * synchrone
     */
    getIndexesIdComDeNonUt: function getIndexesIdComDeNonUt() {
      return ["ESTER", "EONIA", "EUR1W", "EUR1M", "EUR3M", "EUR6M", "EUR12M"];
    },
    /**
     */
    getIndexesBilletTresorerie: function getIndexesBilletTresorerie() {
      return $http.get('/rest/indexes/billet-tresorerie').then(function (response) {
        return _.map(response.data, function (val) {
          return {
            id: val.id,
            //        groupe: $translate('index.groups.' + val.groupe),
            type: val.type,
            label: $translate('index.' + val.id)
          };
        });
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/services/indexationService.js
// module id = 2874
// module chunks = 13